import { styled, css } from 'styled-components';

export const UnsupportedContainer = styled.div`
  ${({ theme: { spacings } }) => css`
    padding: ${spacings.s32};
    text-align: center;
  `}
`;

export const UnsupportedTitle = styled.p`
  ${({ theme: { colors, fontWeights } }) => css`
    font-weight: ${fontWeights.medium};
    color: ${colors.brandDarkAlpha50};
    margin: 0 0 0.25rem 0;
  `}
`;

export const UnsupportedDescription = styled.p`
  ${({ theme: { colors, fontSizes } }) => css`
    font-size: ${fontSizes.s12};
    color: ${colors.brandDarkAlpha50};
    margin: 0;
  `}
`;
